import React from 'react';
import { NextPage } from 'next';
import { GetTermsAPI } from 'api/site';

const Terms: NextPage = ({ data }: any) => {
  return (
    <section style={{ margin: '0 32px' }}>
      <div dangerouslySetInnerHTML={{ __html: data.text }} />
    </section>
  );
};

Terms.getInitialProps = async () => {
  const { data } = await GetTermsAPI('terms');

  return { data };
};

export default Terms;
